document.addEventListener("click", function (event) {
  // Open Full Ingredient List
  if (event.target.closest(".full_ingredient-popopener")) {
    const ingredientTexts = document.querySelector(".all__ingredient-texts");
    if (ingredientTexts) {
      ingredientTexts.classList.add("active");
    }
  }

  // Close Full Ingredient List
  if (event.target.closest(".ingreclose__button")) {
    const ingredientTexts = document.querySelector(".all__ingredient-texts");
    if (ingredientTexts) {
      ingredientTexts.classList.remove("active");
    }
  }

  // Close specific ingredient second box via Close Button
  if (event.target.closest(".close__btn-ingre")) {
    const id = event.target.getAttribute("data-id");

    const secondBox = document.querySelector(
      `.ingredient__second-box[data-id="${id}"]`
    );
    const firstBox = document.querySelector(
      `.ingredient__first-box[data-id="${id}"]`
    );
    const imageBox = document.querySelector(
      `.ingredient__image[data-id="${id}"]`
    );

    secondBox?.classList.remove("active");
    firstBox?.classList.remove("active");
    imageBox?.classList.remove("active");
  }
});

// Toggle individual ingredient box open/close
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".content__displayer").forEach((displayer) => {
    displayer.addEventListener("click", function () {
      const id = this.getAttribute("data-id");

      const firstBox = document.querySelector(
        `.ingredient__first-box[data-id="${id}"]`
      );
      const secondBox = document.querySelector(
        `.ingredient__second-box[data-id="${id}"]`
      );
      const imageBox = document.querySelector(
        `.ingredient__image[data-id="${id}"]`
      );

      firstBox?.classList.toggle("active");
      secondBox?.classList.toggle("active");
      imageBox?.classList.toggle("active");
    });
  });
});
